"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionTypeDefaultForOrganizationMembers = void 0;
const permissionType_1 = require("./permissionType");
/**
 * @see https://coda.io/d/_dgH5XJ_OfpN/Organizations_suzFB#_lu23A
 */
exports.PermissionTypeDefaultForOrganizationMembers = permissionType_1.PermissionType.edit;
//# sourceMappingURL=organizationPermissions.js.map